export default __webpack_public_path__ + "static/media/set_3_Image-2.0417541b.svg";